module.exports = __webpack_public_path__ + "img/img_15.b55b2f22.jpg";